import { Injectable, inject } from '@angular/core';
import { PermissionsApiService, ResourceScope } from '@vendasta/platform-users';
import { Observable, catchError, firstValueFrom, map, of } from 'rxjs';

export interface PlatformPermissions {
  crmContacts?: boolean;
  crmCompanies?: boolean;
}

@Injectable({ providedIn: 'root' })
export class PlatformPermissionsService {
  private readonly permissions: Map<string, PlatformPermissions> = new Map();
  private readonly platformPermissionsService = inject(PermissionsApiService);

  async getPermissions(partnerId: string, userId: string): Promise<PlatformPermissions> {
    const key = `${partnerId}:${userId}`;
    if (this.permissions.has(key)) {
      return this.permissions.get(key);
    }
    const permissions = await firstValueFrom(this.fetchPlatformPermissions(partnerId, userId));
    this.permissions.set(key, permissions);
    return permissions;
  }

  private fetchPlatformPermissions(partnerId: string, userId: string): Observable<PlatformPermissions> {
    return this.platformPermissionsService.getPermissions({ partnerId, userId }).pipe(
      map((resp) => {
        const crmContacts = resp?.permissions?.contacts?.writeScope === ResourceScope.RESOURCE_SCOPE_ALL;
        const crmCompanies = resp?.permissions?.companies?.writeScope === ResourceScope.RESOURCE_SCOPE_ALL;
        return { crmContacts, crmCompanies } as PlatformPermissions;
      }),
      catchError(() => of({} as PlatformPermissions)),
    );
  }
}
